import React from "react";
import Section from "@/components/ui/section";

export default function DataCard({ datas }) {
    const headertxt = datas?.headertxt || {};
    const aboutSection1 = datas?.aboutSection1 || [];

    const renderSection = (section) => {
        const items = [
            { text: section.label1, value: section.desc1 },
            { text: section.label2, value: section.desc2 },
            { text: section.label3, value: section.desc3 },
        ];

        return (
            <>
                <p className="md:text-lg text-sm text-darkGrey underline text-center mx-auto">
                    {section.header}
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 md:gap-12 gap-8 w-full justify-items-center">
                    {items.map((box, index) => (
                        <div
                            key={index}
                            className="flex flex-col justify-center items-center"
                        >
                            <p className="font-havletica font-light md:text-[45px] text-[45px] text-darkGrey leading-tight">
                                {box.text}
                            </p>
                            <div
                                className="font-light !text-[#7F7B78]/80 text-center leading-tight text-sm"
                                dangerouslySetInnerHTML={{ __html: box.value }}
                            />
                        </div>
                    ))}
                </div>
            </>
        );
    };

    return (
        <Section className="bg-[#E9E7DE]">
            <div className="flex flex-col lg:max-w-[785px] mx-auto w-full items-center justify-center gap-8">
                <div className="w-full flex flex-col gap-4 pb-[40px] border-b-darkGrey/50 border-b-[0.5px]">
                    <p className="font-light uppercase text-[#333333]/80 text-lg lg:text-[25px] text-center font-havletica">
                        {headertxt.header}
                    </p>

                    {headertxt.desc && (
                        <p className="text-darkGrey/70 font-light text-center">{headertxt.desc}</p>
                    )}
                    {headertxt.desc1 && (
                        <p className="text-darkGrey/70 font-light text-center">{headertxt.desc1}</p>
                    )}
                </div>

                <div className="flex flex-col gap-10">
                    {aboutSection1.map((section, idx) => renderSection(section.attributes))}
                </div>
            </div>
        </Section>
    );
}
